import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import authRequets from "../../../components/api/authRequests";
import userRequests from "../../../components/api/userRequests";
import FooterGoogle from "../../../components/Common/FooterGoogle";
import FormTitle from "../../../components/Common/FormTitle";
import Input from "../../../components/Common/Input/Input";
import PasswordInput from "../../../components/Common/PasswordInput/PasswordInput";
import SignButton from "../../../components/Common/SignButton/SignButton";
import SubTitleLogin from "../../../components/Common/SubTitleLogin";
import dataContext from "../../../context/dataContext";
import { validate } from "../Signup/validate";
import styles from "./style.module.css";
import mainContext from "../../../context/mainContext";
import { getAuth, getRedirectResult, GoogleAuthProvider } from "firebase/auth/cordova";

export default function SignIn() {
  const [valid, setValid] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  const { loader: { setLoaderFetch } } = useContext(mainContext)
  const { setUserDetails } = useContext(dataContext);

  const getDatafromForm = (formData) => ({
    email: formData.get("email"),
    password: formData.get("password"),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = getDatafromForm(new FormData(e.currentTarget));
    const checkResult = validate(body);
    setValid(checkResult);
    if (checkResult.length) return;
    try {
      setLoaderFetch(true);
      const user = await authRequets.login(body)
      console.log("🚀 ~ file: SignIn.jsx:37 ~ handleSubmit ~ user:", user)
      setUserDetails(user);
      navigate("/", { replace: true, state: body });
      // localStorage.setItem("refresh_token", data?.data?.refreshToken);
      setLoaderFetch(false);
    } catch (err) {
      let errorM = err.message.split("/")[1].split(")")[0].replaceAll("-", " ");
      setError(errorM ? errorM : "Something is wrong")
      console.log(err);
      setLoaderFetch(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setError("")
    }, 2000)

  }, [error])
  useEffect(() => {
    const auth = getAuth();
    getRedirectResult(auth)
      .then((result) => {
        if (result) {

          const credential = GoogleAuthProvider.credentialFromResult(result);
          if (credential) {
            // This gives you a Google Access Token.
            // You can use it to access the Google API.
            const token = credential.accessToken;
            // The signed-in user info.
            const user = result.user;
            // ...
          }
        }
      })
      .catch((error) => {
        console.log("🚀 ~ useEffect ~ error:", error)
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  }, [])
  return (
    <form className={styles.signin} onSubmit={handleSubmit} style={window.buildType == "iPhone" ? { minHeight: "100%" } : {}}>



      <FormTitle content="Welcome back!" />
      <SubTitleLogin content="Don’t have an account?" link="/signup" sign="up" />

      <Input
        legend="Email"
        content="Email"
        type="email"
        name="email"
        onChange={() => setValid(prev => ([]))}
        valid={!valid.includes("email")}
      />
      <PasswordInput
        legend="Password"
        content="Password"
        name="password"
        placeholder="******"
        onChange={() => setValid(prev => ([]))}
        valid={!valid.includes("password")}
      />

      <p style={{ textAlign: "right", textDecoration: "underline", color: "#696979", }} className={styles.forgot} onClick={() => navigate("/forgot-password")}>
        forgot password?
      </p>
      {error &&

        <SubTitleLogin
          content={error}
          color="red"
        //  link="login"
        //  sign="In"
        />
      }
      <div className={styles.btnHolder}>
        <SignButton style={{ cursor: "none" }} content="sign in" type="submit" />
      </div>

      <FooterGoogle />
    </form>
  );
}
